<div class="featured">
	<picture>
		<source media="(min-width: 768px)" [srcset]="image" *ngIf="image">
		<img [src]="cover" *ngIf="cover">
	</picture>
</div>